import WebsiteInformation from './service';
export default {
    WebsiteInformation
};